'use client';

import { FC } from 'react';
import { FlexibleHeroBlockDefault } from './Default/FlexibleHeroBlockDefault';
import { FlexibleHeroBlockStkBka } from './StkBka/FlexibleHeroBlockStkBka';
import { FlexibleHeroBlockProps } from './types';
import { EnumFlexibleHeroBlockHeroType } from '$/(cms)/_modules/cmsService/types';
import { VerticalType } from '$/components/cms/types';

/**
 * Verticals whose Product hero has a layout of its own. This is the only place
 * the hero's layout is picked by vertical: a vertical that needs a different
 * Product hero gets a variant folder and a line here. Every other hero type — and the
 * Product hero of any vertical not listed (CC included) — renders the default.
 */
const PRODUCT_HERO_VARIANTS: Partial<
  Record<VerticalType, FC<FlexibleHeroBlockProps>>
> = {
  INVESTMENTS: FlexibleHeroBlockStkBka,
  BANKING: FlexibleHeroBlockStkBka,
};

export const FlexibleHeroBlock: FC<
  FlexibleHeroBlockProps & {
    /**
     * Vertical the hero renders under — the page's `section`. The #usePDP
     * modal passes none (it opens for credit cards only), so a modal hero
     * always renders the default variant.
     */
    vertical?: VerticalType;
  }
> = ({ vertical, ...props }) => {
  const Variant =
    (props.heroType === EnumFlexibleHeroBlockHeroType.Product &&
      vertical &&
      PRODUCT_HERO_VARIANTS[vertical]) ||
    FlexibleHeroBlockDefault;

  return <Variant {...props} />;
};
